















import { isEmpty } from "lodash"
import { Component, Vue } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  computed: {
    ...mapState("RiskProfileTemplate", {
      riskProfileTree: "riskProfileTree",
    }),
  },
})
export default class RiskProfileOptions extends Vue {
  riskProfileTree: Nullable<Model>

  optionTickValues = [0.1, 0.2, 0.5, 0.8, 1.0]

  errors = {}

  reload = 0

  get items() {
    if (this.riskProfileTree) {
      for (const [index, section] of this.riskProfileTree.entries()) {
        for (const [key, sub_section] of section.sub_sections.entries()) {
          sub_section.items
            .map((item) => {
              if (isEmpty(item.edge_extform_value)) {
                item.edge_extform_value = item.extform_default_value
              }
              return item
            })
            .sort((a, b) => a.display_order - b.display_order)
        }
      }
    }

    return this.riskProfileTree || []
  }

  set items(value) {
    this.$store.commit("RiskProfileTemplate/SET_RISK_PROFILE_TREE", value)
  }

  validate() {
    if (!this.riskProfileTree) {
      return false
    }

    // reset errors
    this.errors = {}

    for (const [index, section] of this.riskProfileTree.entries()) {
      for (const subSection of section.sub_sections) {
        for (const item of subSection.items) {
          // only validate the risk profile items that have the selected form type and extra form value is undefined and
          // the risk profile item is enabled
          if (
            [
              "radiobutton",
              "checkbox",
              "dropdown_single",
              "dropdown_multiple",
            ].includes(item.extform_type) &&
            (item.edge_extform_value == undefined ||
              item.edge_extform_value == null) &&
            item.edge_is_enabled
          ) {
            // construct the errors structure
            if (!this.errors[this.riskProfileTree[index].object_id]) {
              this.errors[this.riskProfileTree[index].object_id] = {}
            }

            if (
              !this.errors[this.riskProfileTree[index].object_id][
                subSection.object_id
              ]
            ) {
              this.errors[this.riskProfileTree[index].object_id][
                subSection.object_id
              ] = []
            }

            // merge the object ids of the risk profile items that has empty extra form value
            this.errors[this.riskProfileTree[index].object_id][
              subSection.object_id
            ] = [
              ...this.errors[this.riskProfileTree[index].object_id][
                subSection.object_id
              ],
              item.object_id,
            ]
          }
        }
      }
    }
    this.reload++

    return !Object.keys(this.errors).length
  }
}
